/* eslint-disable react/forbid-dom-props -- This drawer uses inline offsets based on runtime width and open state. */
import { ReactElement, ReactNode, useEffect } from 'react';
import classes from './style.module.scss';
import DisableGlobalLoading from '@/features/GlobalLoading/disable-global-loading';

interface Properties {
  readonly children: ReactNode;
  readonly drawerWidth: number;
}

const Drawer = ({ children, drawerWidth }: Properties): ReactElement => {
  useEffect(() => {
    document.body.style.overflow = children ? 'hidden' : 'auto';

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [children]);

  return (
    <>
      {children ? (
        <>
          <div className={classes.overlay} />
          <DisableGlobalLoading />
        </>
      ) : null}
      <div style={{ width: `${drawerWidth}px`, right: children ? 0 : -drawerWidth }} className={classes.drawer}>
        {children}
      </div>
    </>
  );
};

export default Drawer;
/* eslint-enable react/forbid-dom-props -- Restore the default DOM prop restriction outside this drawer. */
